(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';let busy=false,lastFocus=null;
  const section=()=>document.querySelector('[data-bbcd-section]');
  const drawer=()=>section()?.querySelector('.bbcd');
  const sid=()=>section()?.dataset.sectionId||'';
  function prepareHeader(){document.querySelectorAll('.js-drawer-open-cart').forEach(a=>{a.classList.remove('js-drawer-open-cart');a.setAttribute('data-bbcd-open','');a.setAttribute('aria-haspopup','dialog');a.setAttribute('aria-controls','BbCartDrawer')})}
  function bubble(){const n=Number(section()?.dataset.count||0);document.querySelectorAll('.cart-link__bubble').forEach(b=>b.classList.toggle('cart-link__bubble--visible',n>0))}
  function open(){const d=drawer();if(!d)return;lastFocus=document.activeElement;d.setAttribute('aria-hidden','false');document.documentElement.classList.add('bb-cart-open');requestAnimationFrame(()=>{d.classList.add('is-open');d.querySelector('[data-bbcd-close]')?.focus({preventScroll:true})})}
  function close(){const d=drawer();if(!d)return;d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.documentElement.classList.remove('bb-cart-open');lastFocus?.focus?.({preventScroll:true})}
  function notice(t){const n=drawer()?.querySelector('[data-bbcd-notice]');if(!n)return;n.textContent=t||'';n.hidden=!t}
  async function render(html,doOpen=true){if(!html){const id=sid();if(!id)return;html=await(await fetch(location.pathname+'?section_id='+encodeURIComponent(id))).text()}const doc=new DOMParser().parseFromString(html,'text/html'),next=doc.querySelector('[data-bbcd-section]'),cur=section();if(next&&cur)cur.replaceWith(next);bubble();prepareHeader();if(doOpen)open()}
  async function add(form){if(busy)return;busy=true;const btn=form.querySelector('[type=submit]');btn?.classList.add('is-loading');notice('');try{const id=sid(),body=new FormData(form);if(!id)throw Error('Warenkorb konnte nicht aktualisiert werden.');body.set('sections',id);body.set('sections_url',location.pathname);const r=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body}),d=await r.json();if(!r.ok)throw Error(d.description||d.message||'Das Produkt konnte nicht hinzugefügt werden.');await render(d.sections?.[id]);document.dispatchEvent(new CustomEvent('bb:cart-updated',{detail:d}))}catch(e){notice(e.message||'Bitte versuche es erneut.');open()}finally{busy=false;btn?.classList.remove('is-loading')}}
  async function change(key,quantity){if(busy)return;busy=true;notice('');try{const id=sid();if(!id)throw Error('Warenkorb konnte nicht aktualisiert werden.');const r=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:key,quantity:Math.max(0,quantity),sections:id,sections_url:location.pathname})}),d=await r.json();if(!r.ok)throw Error(d.description||d.message||'Die Menge konnte nicht geändert werden.');await render(d.sections?.[id]);document.dispatchEvent(new CustomEvent('bb:cart-updated',{detail:d}))}catch(e){notice(e.message||'Bitte versuche es erneut.')}finally{busy=false}}
  document.addEventListener('submit',e=>{const f=e.target.closest('.bb-product__form,.bb-card__form,.bbcd__upsell-form,form[data-bb-ajax-cart]');if(!f)return;e.preventDefault();e.stopImmediatePropagation();add(f)},true);
  document.addEventListener('click',e=>{if(e.target.closest('[data-bbcd-open]')){e.preventDefault();e.stopImmediatePropagation();open();return}if(e.target.closest('[data-bbcd-close]')){e.preventDefault();close();return}const r=e.target.closest('[data-bbcd-remove]');if(r){change(r.dataset.key,0);return}const p=e.target.closest('[data-bbcd-plus]'),m=e.target.closest('[data-bbcd-minus]');if(p||m){const b=p||m,i=b.closest('[data-bbcd-line]')?.querySelector('[data-bbcd-input]'),q=Math.max(0,parseInt(i?.value||'0',10));change(b.dataset.key,q+(p?1:-1))}},true);
  document.addEventListener('change',e=>{const i=e.target.closest('[data-bbcd-input]');if(i)change(i.dataset.key,Math.max(0,parseInt(i.value||'0',10)))});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer()?.classList.contains('is-open'))close()});
  prepareHeader();bubble();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-cart-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  const template = document.querySelector('[data-bb-cart-journey-template]');
  if (!template) return;

  function enhanceDrawer() {
    document.querySelectorAll('.bbcd__foot').forEach(function (foot) {
      const message = foot.querySelector('small');
      if (message) message.textContent = 'Versandkosten und mögliche Rabatte werden im Checkout angezeigt.';
      if (foot.querySelector('[data-bb-cart-journey]')) return;
      const checkout = foot.querySelector('.bbcd__checkout');
      if (!checkout) return;
      const journey = template.content.firstElementChild.cloneNode(true);
      checkout.insertAdjacentElement('afterend', journey);
    });
  }

  enhanceDrawer();
  document.addEventListener('bb:cart-updated', enhanceDrawer);
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.js-drawer-open-cart,[data-bbcd-open]')) return;
    window.requestAnimationFrame(enhanceDrawer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-collection-discovery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function place(root){
    var hero = document.querySelector('.bb-collection__hero');
    if(hero && hero.nextElementSibling !== root) hero.insertAdjacentElement('afterend', root);
  }
  document.querySelectorAll('[data-bbg-discovery]').forEach(place);
  document.addEventListener('shopify:section:load', function(event){
    event.target.querySelectorAll('[data-bbg-discovery]').forEach(place);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-collection-growth"] && !Shopify.designMode) return;
  try {
    
(function(){
  function withProductsAnchor(href){
    if(!href) return href;
    return href.split('#')[0] + '#BbgProducts';
  }

  function enhance(root){
    if(!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var form = document.querySelector('[data-bb-facets]');
    var panel = form && form.querySelector('[data-bb-filter-panel]');
    var toggle = form && form.querySelector('[data-bb-filter-toggle]');
    var productGrid = document.querySelector('.bb-product-grid--collection');
    if(!form || !panel || !toggle) return;

    if(productGrid && !productGrid.id) productGrid.id = 'BbgProducts';
    form.setAttribute('action', withProductsAnchor(form.getAttribute('action')));

    form.querySelectorAll('.bb-facets__active a').forEach(function(link){
      link.setAttribute('href', withProductsAnchor(link.getAttribute('href')));
    });
    document.querySelectorAll('.bb-pagination a').forEach(function(link){
      link.setAttribute('href', withProductsAnchor(link.getAttribute('href')));
    });

    var applyButton = form.querySelector('.bb-facets__apply');
    if(applyButton) applyButton.textContent = 'Produkte anzeigen';

    var activeCount = form.querySelectorAll('.bb-facets__active a:not(.bb-facets__clear)').length;
    toggle.innerHTML = 'Filter' + (activeCount ? ' (' + activeCount + ')' : '') + ' <span aria-hidden="true">+</span>';

    if(!panel.querySelector('[data-bbg-filter-close]')){
      var head = document.createElement('div');
      head.className = 'bbg-filter-head';
      head.innerHTML = '<div><small>PRODUKTE EINGRENZEN</small><strong>Filter</strong></div><button type="button" data-bbg-filter-close aria-label="Filter schließen">&times;</button>';
      panel.insertBefore(head, panel.firstChild);
    }

    var backdrop = form.querySelector('[data-bbg-filter-backdrop]');
    if(!backdrop){
      backdrop = document.createElement('button');
      backdrop.type = 'button';
      backdrop.className = 'bbg-filter-backdrop';
      backdrop.setAttribute('data-bbg-filter-backdrop','');
      backdrop.setAttribute('aria-label','Filter schließen');
      backdrop.hidden = true;
      form.appendChild(backdrop);
    }

    var closeButton = panel.querySelector('[data-bbg-filter-close]');
    var mobileQuery = window.matchMedia('(max-width: 989px)');

    function isOpen(){
      return mobileQuery.matches && toggle.getAttribute('aria-expanded') === 'true' && panel.classList.contains('is-open');
    }

    function getFocusable(){
      return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),a[href],summary,[tabindex]:not([tabindex="-1"])')).filter(function(item){
        return item.offsetParent !== null;
      });
    }

    function sync(focusClose){
      var open = isOpen();
      if(!mobileQuery.matches){
        backdrop.hidden = true;
        document.body.classList.remove('bbg-filter-open');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        panel.removeAttribute('aria-hidden');
        return;
      }

      backdrop.hidden = !open;
      document.body.classList.toggle('bbg-filter-open', open);
      panel.setAttribute('role','dialog');
      panel.setAttribute('aria-modal','true');
      panel.setAttribute('aria-hidden', String(!open));

      if(open && focusClose){
        window.requestAnimationFrame(function(){ if(closeButton) closeButton.focus({preventScroll:true}); });
      }
    }

    function close(returnFocus){
      toggle.setAttribute('aria-expanded','false');
      panel.classList.remove('is-open');
      sync(false);
      if(returnFocus !== false) toggle.focus({preventScroll:true});
    }

    toggle.addEventListener('click', function(){
      window.setTimeout(function(){ sync(toggle.getAttribute('aria-expanded') === 'true'); }, 0);
    });
    backdrop.addEventListener('click', function(){ close(true); });
    closeButton.addEventListener('click', function(){ close(true); });

    document.addEventListener('keydown', function(event){
      if(!isOpen()) return;
      if(event.key === 'Escape'){
        event.preventDefault();
        close(true);
        return;
      }
      if(event.key !== 'Tab') return;
      var focusable = getFocusable();
      if(!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if(event.shiftKey && document.activeElement === first){
        event.preventDefault();
        last.focus();
      } else if(!event.shiftKey && document.activeElement === last){
        event.preventDefault();
        first.focus();
      }
    });

    function handleMediaChange(){
      if(!mobileQuery.matches) close(false);
      sync(false);
    }
    if(mobileQuery.addEventListener) mobileQuery.addEventListener('change', handleMediaChange);
    else if(mobileQuery.addListener) mobileQuery.addListener(handleMediaChange);

    sync(false);
  }

  document.querySelectorAll('[data-bbg-collection-growth]').forEach(enhance);
  document.addEventListener('shopify:section:load', function(event){
    event.target.querySelectorAll('[data-bbg-collection-growth]').forEach(enhance);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-final-conversion"] && !Shopify.designMode) return;
  try {
    
(function(){
  var initialHadVariant = false;
  try { initialHadVariant = new URL(window.location.href).searchParams.has('variant'); } catch(error) {}
  var initialWindowOpen = true;
  var cartRequest = 0;
  window.setTimeout(function(){ initialWindowOpen = false; }, 900);

  function readVariantMap(){
    var root = document.querySelector('[data-bbg-product-map]');
    var map = {};
    if(!root) return map;
    root.querySelectorAll('[data-bbg-variant]').forEach(function(node){
      map[String(node.dataset.variantId)] = {
        id: String(node.dataset.variantId),
        price: Number(node.dataset.priceCents || 0),
        money: node.dataset.money || '',
        compareMoney: node.dataset.compareMoney || '',
        available: node.dataset.available === 'true'
      };
    });
    return map;
  }

  function selectPositiveVariant(select, map){
    if(!select) return false;
    for(var i = 0; i < select.options.length; i += 1){
      var option = select.options[i];
      var meta = map[String(option.value)];
      if(meta && meta.price > 0 && meta.available && !option.disabled){
        if(String(select.value) !== String(option.value)){
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles:true}));
        }
        return true;
      }
    }
    return false;
  }

  function annotateVariantPills(map){
    document.querySelectorAll('.bb-variant-pill[data-variant-id]').forEach(function(pill){
      var meta = map[String(pill.dataset.variantId)];
      var missing = !!meta && meta.price <= 0;
      pill.classList.toggle('is-price-missing', missing);
      if(missing) pill.setAttribute('title', 'Preis derzeit nicht verfügbar');
      else if(pill.getAttribute('title') === 'Preis derzeit nicht verfügbar') pill.removeAttribute('title');
    });
  }

  function syncProduct(allowInitialSwitch){
    var productRoot = document.querySelector('[data-bb-product]');
    var form = productRoot && productRoot.querySelector('.bb-product__form');
    var map = readVariantMap();
    if(!productRoot || !form || !Object.keys(map).length) return;

    var select = form.querySelector('[data-bb-variant]');
    var idInput = form.querySelector('input[name="id"]');
    var selectedId = select ? String(select.value) : (idInput ? String(idInput.value) : '');
    var meta = map[selectedId];
    annotateVariantPills(map);
    if(!meta) return;

    if(meta.price <= 0 && allowInitialSwitch && !initialHadVariant && select && selectPositiveVariant(select, map)){
      window.setTimeout(function(){ syncProduct(false); }, 0);
      return;
    }

    var priceMissing = meta.price <= 0;
    var purchasable = meta.available && !priceMissing;
    var addButton = form.querySelector('[data-bb-add]');
    var addLabel = form.querySelector('[data-bb-add-text]');
    var priceNode = productRoot.querySelector('[data-bb-price-current]');
    var compareNode = productRoot.querySelector('[data-bb-price-compare]');
    var status = productRoot.querySelector('[data-bb-status]');
    var statusText = productRoot.querySelector('[data-bb-status-text]');
    var payment = form.querySelector('.bb-product__payment');
    var sticky = document.querySelector('[data-bb-sticky-atc]');
    var stickyPrice = sticky && sticky.querySelector('[data-bb-sticky-price]');
    var stickyButton = sticky && sticky.querySelector('[data-bb-sticky-submit]');
    var stickyLabel = sticky && sticky.querySelector('[data-bb-sticky-label]');

    if(priceMissing) form.dataset.bbgPurchaseBlocked = 'true';
    else form.removeAttribute('data-bbg-purchase-blocked');

    if(priceNode) priceNode.textContent = priceMissing ? 'Preis derzeit nicht verfügbar' : meta.money;
    if(compareNode){
      compareNode.textContent = priceMissing ? '' : meta.compareMoney;
      compareNode.hidden = priceMissing || !meta.compareMoney;
    }
    if(status) status.classList.toggle('is-out', !purchasable);
    if(statusText) statusText.textContent = priceMissing ? 'Preis derzeit nicht verfügbar' : (meta.available ? 'Sofort verfügbar' : 'Ausverkauft');
    if(addButton) addButton.disabled = !purchasable;
    if(addLabel) addLabel.textContent = priceMissing ? 'Derzeit nicht kaufbar' : (meta.available ? 'In den Warenkorb' : 'Ausverkauft');
    if(payment) payment.hidden = !purchasable;

    if(stickyPrice) stickyPrice.textContent = priceMissing ? 'Preis nicht verfügbar' : meta.money;
    if(stickyButton) stickyButton.disabled = !purchasable;
    if(stickyLabel) stickyLabel.textContent = priceMissing ? 'Preis fehlt' : (meta.available ? 'In den Warenkorb' : 'Ausverkauft');
  }

  function parseDisplayedMoney(text){
    var compact = String(text || '').replace(/\s/g,'').replace(/[^\d,.-]/g,'');
    if(!compact) return null;
    var normalized = compact.indexOf(',') > -1 ? compact.replace(/\./g,'').replace(',','.') : compact;
    var number = Number.parseFloat(normalized);
    return Number.isFinite(number) ? number : null;
  }

  function syncUpsell(){
    document.querySelectorAll('.bbcd__upsell').forEach(function(upsell){
      var form = upsell.querySelector('.bbcd__upsell-form');
      if(!form) return;
      var priceNode = upsell.querySelector('.bbcd__upsell-copy>strong');
      var button = form.querySelector('button[type="submit"]');
      var value = parseDisplayedMoney(priceNode && priceNode.textContent);
      var missing = value !== null && value <= 0;
      if(missing){
        form.dataset.bbgPurchaseBlocked = 'true';
        if(priceNode) priceNode.textContent = 'Preis derzeit nicht verfügbar';
        if(button){
          button.disabled = true;
          button.dataset.bbgPriceDisabled = 'true';
          button.textContent = 'Preis fehlt';
        }
      } else {
        form.removeAttribute('data-bbg-purchase-blocked');
        if(button && button.dataset.bbgPriceDisabled === 'true'){
          button.disabled = false;
          button.removeAttribute('data-bbg-price-disabled');
        }
      }
    });
  }

  function formatMoney(cents, currency){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:currency || 'EUR'}).format((cents || 0) / 100);
    } catch(error) {
      return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function setDiscountRow(anchor, key, cart){
    if(!anchor || !anchor.parentElement) return;
    var parent = anchor.parentElement;
    var row = parent.querySelector('[data-bbg-discount="' + key + '"]');
    if(!cart.total_discount || cart.total_discount <= 0){
      if(row) row.remove();
      return;
    }
    if(!row){
      row = document.createElement('div');
      row.className = 'bbg-discount-row';
      row.setAttribute('data-bbg-discount', key);
      var label = document.createElement('span');
      var amount = document.createElement('strong');
      label.textContent = 'Rabatt bereits abgezogen';
      row.appendChild(label);
      row.appendChild(amount);
      anchor.insertAdjacentElement('afterend', row);
    }
    var amountNode = row.querySelector('strong');
    if(amountNode) amountNode.textContent = '−' + formatMoney(cart.total_discount, cart.currency);
  }

  function applyCartData(cart){
    setDiscountRow(document.querySelector('.bbcd__subtotal'), 'drawer', cart);
    setDiscountRow(document.querySelector('.bb-cart-summary__top'), 'page', cart);
  }

  function refreshCart(){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var requestId = ++cartRequest;
    fetch(root + 'cart.js', {headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}})
      .then(function(response){ if(!response.ok) throw new Error('cart'); return response.json(); })
      .then(function(cart){ if(requestId === cartRequest) applyCartData(cart); })
      .catch(function(){});
  }

  document.addEventListener('submit', function(event){
    var form = event.target;
    if(!form || !form.matches) return;
    if(form.matches('.bb-product__form,.bbcd__upsell-form') && form.dataset.bbgPurchaseBlocked === 'true'){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function(event){
    if(event.target.matches('[data-bb-variant]')){
      window.setTimeout(function(){ syncProduct(initialWindowOpen && !initialHadVariant); }, 0);
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key !== 'Tab') return;
    var drawer = document.querySelector('.bbcd.is-open');
    var panel = drawer && drawer.querySelector('.bbcd__panel');
    if(!panel) return;
    var focusable = Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])')).filter(function(item){
      return item.offsetParent !== null;
    });
    if(!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if(event.shiftKey && document.activeElement === first){
      event.preventDefault();
      last.focus();
    } else if(!event.shiftKey && document.activeElement === last){
      event.preventDefault();
      first.focus();
    }
  });

  function ready(){
    window.requestAnimationFrame(function(){ syncProduct(true); syncUpsell(); });
    window.setTimeout(function(){ syncProduct(true); syncUpsell(); }, 250);
    window.setTimeout(function(){ syncProduct(true); syncUpsell(); }, 650);
    if(document.querySelector('.bb-cart-page')) refreshCart();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();

  document.addEventListener('bb:cart-updated', function(){
    window.requestAnimationFrame(function(){ syncUpsell(); refreshCart(); });
  });

  document.addEventListener('click', function(event){
    if(event.target.closest('[data-bbcd-open],.js-drawer-open-cart')){
      window.requestAnimationFrame(function(){ syncUpsell(); refreshCart(); });
    }
  }, true);

  document.addEventListener('shopify:section:load', function(){
    window.requestAnimationFrame(function(){ syncProduct(false); syncUpsell(); if(document.querySelector('.bb-cart-page')) refreshCart(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-hero-video-fix"]) return;
  try {
    
(function(){
  function boot(){
    const videos=document.querySelectorAll('.bb-hero__video');
    if(!videos.length)return;
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const inView=new WeakMap();

    const mayPlay=video=>!document.hidden&&!reducedMotion.matches&&inView.get(video)!==false;
    const prepare=video=>{
      video.muted=true;
      video.defaultMuted=true;
      video.playsInline=true;
      video.controls=false;
      video.setAttribute('muted','');
      video.setAttribute('playsinline','');
      video.setAttribute('webkit-playsinline','');
      video.removeAttribute('controls');
    };
    const tryPlay=video=>{
      prepare(video);
      if(!mayPlay(video)){
        video.pause();
        return;
      }
      video.setAttribute('autoplay','');
      const promise=video.play();
      if(promise&&typeof promise.catch==='function')promise.catch(()=>{});
    };
    const sync=()=>videos.forEach(video=>{
      if(reducedMotion.matches){
        video.removeAttribute('autoplay');
        video.pause();
      }else if(document.hidden||inView.get(video)===false){
        video.pause();
      }else{
        tryPlay(video);
      }
    });

    videos.forEach(video=>{
      inView.set(video,true);
      prepare(video);
      if(reducedMotion.matches){
        video.removeAttribute('autoplay');
        video.pause();
      }else if(video.readyState>=2){
        tryPlay(video);
      }else{
        video.addEventListener('canplay',()=>tryPlay(video),{once:true});
      }
    });

    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          inView.set(entry.target,entry.isIntersecting);
          if(entry.isIntersecting)tryPlay(entry.target);
          else entry.target.pause();
        });
      },{rootMargin:'120px 0px',threshold:.01});
      videos.forEach(video=>observer.observe(video));
    }

    document.addEventListener('visibilitychange',sync);
    window.addEventListener('pageshow',sync);
    if(typeof reducedMotion.addEventListener==='function')reducedMotion.addEventListener('change',sync);
    else if(typeof reducedMotion.addListener==='function')reducedMotion.addListener(sync);

    const resume=()=>sync();
    document.addEventListener('pointerdown',resume,{once:true,passive:true});
    document.addEventListener('touchstart',resume,{once:true,passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-main-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const minus = event.target.closest('[data-bb-cart-minus]');
  const plus = event.target.closest('[data-bb-cart-plus]');
  if (!minus && !plus) return;
  const wrapper = event.target.closest('[data-bb-cart-qty]');
  const input = wrapper && wrapper.querySelector('[data-bb-cart-input]');
  if (!input) return;
  const value = Number.parseInt(input.value || '0', 10);
  input.value = Math.max(0, value + (plus ? 1 : -1));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-main-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-bb-sort]')) event.target.form.submit();
});
document.addEventListener('click', function(event) {
  const toggle = event.target.closest('[data-bb-filter-toggle]');
  if (!toggle) return;
  const panel = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!panel) return;
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  panel.classList.toggle('is-open', !open);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const minus = event.target.closest('[data-bb-qty-minus]');
  const plus = event.target.closest('[data-bb-qty-plus]');
  if (!minus && !plus) return;
  const wrap = event.target.closest('[data-bb-qty]');
  const input = wrap.querySelector('[data-bb-qty-input]');
  const value = Math.max(1, Number.parseInt(input.value || '1', 10) + (plus ? 1 : -1));
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-bb-variant]');
  if (!select) return;
  const product = select.closest('[data-bb-product]');
  const option = select.options[select.selectedIndex];
  const price = product.querySelector('[data-bb-price-current]');
  const compare = product.querySelector('[data-bb-price-compare]');
  const status = product.querySelector('[data-bb-status]');
  const statusText = product.querySelector('[data-bb-status-text]');
  const add = product.querySelector('[data-bb-add]');
  const addText = product.querySelector('[data-bb-add-text]');
  const available = option.dataset.available === 'true';
  price.textContent = option.dataset.price || '';
  if (option.dataset.compare) {
    compare.textContent = option.dataset.compare;
    compare.hidden = false;
  } else {
    compare.hidden = true;
  }
  status.classList.toggle('is-out', !available);
  statusText.textContent = available ? 'Verfügbar' : 'Aktuell nicht verfügbar';
  add.disabled = !available;
  addText.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-product-enhancements"] && !Shopify.designMode) return;
  try {
    
(function () {
  const products = document.querySelectorAll('[data-bb-product]');
  if (!products.length) return;

  function variantSortValue(text, fallbackIndex) {
    const label = String(text || '').split(' · ')[0].trim().toLowerCase().replace(',', '.');
    const weight = label.match(/(\d+(?:\.\d+)?)\s*(kg|kilogramm|kilogram|g|gr|gramm|gram)\b/i);
    if (weight) {
      const value = Number.parseFloat(weight[1]) * (/^k/i.test(weight[2]) ? 1000 : 1);
      return [1, value, fallbackIndex];
    }

    const pieces = label.match(/(\d+(?:\.\d+)?)\s*(stück|stueck|stk|pcs?)\b/i);
    if (pieces) return [2, Number.parseFloat(pieces[1]), fallbackIndex];
    if (/^(stück|stueck|stk)$/i.test(label)) return [2, 1, fallbackIndex];

    const sizes = { xs: 1, s: 2, m: 3, l: 4, xl: 5, xxl: 6, xxxl: 7 };
    const normalizedSize = label.replace(/\s+/g, '');
    if (Object.prototype.hasOwnProperty.call(sizes, normalizedSize)) return [3, sizes[normalizedSize], fallbackIndex];

    const number = label.match(/^(\d+(?:\.\d+)?)/);
    if (number) return [4, Number.parseFloat(number[1]), fallbackIndex];
    return [9, fallbackIndex, fallbackIndex];
  }

  function sortVariantOptions(select) {
    const items = Array.from(select.options).map(function (option, index) {
      return { option: option, sort: variantSortValue(option.textContent, index) };
    });

    items.sort(function (a, b) {
      for (let index = 0; index < a.sort.length; index += 1) {
        if (a.sort[index] !== b.sort[index]) return a.sort[index] - b.sort[index];
      }
      return 0;
    });

    items.forEach(function (item) { select.appendChild(item.option); });
    return items;
  }

  products.forEach(function (product) {
    const gallery = product.querySelector('[data-bb-gallery]');
    const grid = gallery && gallery.querySelector('.bb-product__media-grid');
    const mediaItems = grid ? Array.from(grid.querySelectorAll('.bb-product__media')) : [];

    if (gallery && grid && mediaItems.length > 1 && !gallery.querySelector('[data-bb-enhanced-gallery-nav]')) {
      const nav = document.createElement('div');
      nav.className = 'bb-product__gallery-nav bb-product__gallery-nav--enhanced';
      nav.setAttribute('data-bb-enhanced-gallery-nav', '');

      const dots = document.createElement('div');
      dots.className = 'bb-product__gallery-dots';
      dots.setAttribute('aria-label', 'Produktbilder');

      const status = document.createElement('div');
      status.className = 'bb-product__gallery-status';
      const current = document.createElement('span');
      current.textContent = '1';
      const total = document.createTextNode(' / ' + mediaItems.length + ' ');
      const hint = document.createElement('small');
      hint.textContent = 'Wischen · antippen zum Vergrößern';
      status.append(current, total, hint);

      function setActive(index) {
        current.textContent = String(index + 1);
        dots.querySelectorAll('button').forEach(function (dot, dotIndex) {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      mediaItems.forEach(function (item, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bb-product__gallery-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Bild ' + (index + 1) + ' von ' + mediaItems.length);
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          const paddingLeft = parseFloat(getComputedStyle(grid).paddingLeft) || 0;
          const delta = item.getBoundingClientRect().left - grid.getBoundingClientRect().left - paddingLeft;
          grid.scrollBy({ left: delta, behavior: 'smooth' });
          setActive(index);
        });
        dots.appendChild(dot);
      });

      nav.append(dots, status);
      grid.insertAdjacentElement('afterend', nav);

      let frame = 0;
      grid.addEventListener('scroll', function () {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          const rect = grid.getBoundingClientRect();
          const target = rect.left + rect.width / 2;
          let bestIndex = 0;
          let bestDistance = Infinity;
          mediaItems.forEach(function (item, index) {
            const itemRect = item.getBoundingClientRect();
            const distance = Math.abs(itemRect.left + itemRect.width / 2 - target);
            if (distance < bestDistance) {
              bestDistance = distance;
              bestIndex = index;
            }
          });
          setActive(bestIndex);
        });
      }, { passive: true });
    }

    const select = product.querySelector('[data-bb-variant]');
    if (select && select.options.length <= 8 && !product.querySelector('[data-bb-variant-pills]')) {
      const field = select.closest('.bb-product__field');
      const selectWrap = select.closest('.bb-select-wrap');
      if (field && selectWrap) {
        const orderedOptions = sortVariantOptions(select);
        let shouldSelectSmallest = false;
        try {
          shouldSelectSmallest = !new URL(window.location.href).searchParams.has('variant');
        } catch (error) {
          shouldSelectSmallest = true;
        }

        const smallestAvailable = orderedOptions.find(function (item) { return !item.option.disabled; });
        const initialValue = select.value;
        if (shouldSelectSmallest && smallestAvailable) select.value = smallestAvailable.option.value;

        const pills = document.createElement('div');
        pills.className = 'bb-variant-pills';
        pills.setAttribute('data-bb-variant-pills', '');
        pills.setAttribute('role', 'group');
        pills.setAttribute('aria-label', 'Variante wählen');

        orderedOptions.forEach(function (item) {
          const option = item.option;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'bb-variant-pill';
          button.dataset.variantId = option.value;
          button.disabled = option.disabled;

          const parts = option.textContent.trim().split(' · ');
          const title = document.createElement('span');
          title.textContent = parts[0] || option.textContent.trim();
          const meta = document.createElement('small');
          meta.textContent = parts.slice(1).join(' · ');
          button.append(title, meta);

          button.addEventListener('click', function () {
            if (button.disabled) return;
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
          pills.appendChild(button);
        });

        function syncPills() {
          pills.querySelectorAll('[data-variant-id]').forEach(function (button) {
            const active = button.dataset.variantId === select.value;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }

        selectWrap.classList.add('bb-select-wrap--enhanced');
        field.appendChild(pills);
        syncPills();
        select.addEventListener('change', function () {
          syncPills();
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', select.value);
            window.history.replaceState({}, '', url.toString());
          } catch (error) {}
        });

        if (select.value !== initialValue) select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (window.innerWidth <= 640) {
      const description = product.querySelector('.bb-product__details details[open]');
      if (description) description.removeAttribute('open');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-product-lightbox"] && !Shopify.designMode) return;
  try {
    
(function () {
  const shell = document.querySelector('[data-bb-zoom-shell]');
  if (!shell) return;

  const dialog = shell.querySelector('[data-bb-zoom-dialog]');
  const zoomImage = shell.querySelector('[data-bb-zoom-image]');
  const counter = shell.querySelector('[data-bb-zoom-counter]');
  const prevButton = shell.querySelector('[data-bb-zoom-prev]');
  const nextButton = shell.querySelector('[data-bb-zoom-next]');
  const closeButton = shell.querySelector('.bb-zoom-close');
  const figure = shell.querySelector('[data-bb-zoom-figure]');
  let images = [];
  let activeIndex = 0;
  let previousFocus = null;
  let touchStartX = 0;

  function largeImageUrl(source) {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '2400');
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function collectImages() {
    images = Array.from(document.querySelectorAll('.bb-product__media img'));
  }

  function renderImage() {
    const sourceImage = images[activeIndex];
    if (!sourceImage) return;
    zoomImage.src = largeImageUrl(sourceImage.currentSrc || sourceImage.src);
    zoomImage.alt = sourceImage.alt || 'Produktbild';
    counter.textContent = images.length > 1 ? (activeIndex + 1) + ' / ' + images.length : '';
    const showNavigation = images.length > 1;
    prevButton.hidden = !showNavigation;
    nextButton.hidden = !showNavigation;
  }

  function openZoom(sourceImage) {
    collectImages();
    const index = images.indexOf(sourceImage);
    activeIndex = index >= 0 ? index : 0;
    previousFocus = document.activeElement;
    renderImage();
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bb-zoom-open');
    window.requestAnimationFrame(function () {
      shell.classList.add('is-open');
      closeButton.focus();
    });
  }

  function closeZoom() {
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bb-zoom-open');
    window.setTimeout(function () {
      shell.hidden = true;
      zoomImage.removeAttribute('src');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }, 180);
  }

  function move(direction) {
    if (images.length < 2) return;
    activeIndex = (activeIndex + direction + images.length) % images.length;
    renderImage();
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]):not([hidden]),a[href],[tabindex]:not([tabindex="-1"])')).filter(function(element){
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    const productImage = event.target.closest('.bb-product__media img');
    if (productImage) {
      event.preventDefault();
      openZoom(productImage);
      return;
    }
    if (event.target.closest('[data-bb-zoom-close]')) {
      closeZoom();
      return;
    }
    if (event.target.closest('[data-bb-zoom-prev]')) {
      move(-1);
      return;
    }
    if (event.target.closest('[data-bb-zoom-next]')) move(1);
  });

  document.addEventListener('keydown', function (event) {
    if (shell.hidden) return;
    if (event.key === 'Tab') trapFocus(event);
    if (event.key === 'Escape') closeZoom();
    if (event.key === 'ArrowLeft') move(-1);
    if (event.key === 'ArrowRight') move(1);
  });

  figure.addEventListener('touchstart', function (event) {
    touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });

  figure.addEventListener('touchend', function (event) {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) < 45) return;
    move(distance > 0 ? -1 : 1);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-product-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){const bar=document.querySelector('[data-bb-sticky-atc]'),product=document.querySelector('[data-bb-product]');if(!bar||!product)return;const form=product.querySelector('.bb-product__form'),buy=product.querySelector('[data-bb-main-buyrow]')||form?.querySelector('.bb-product__buyrow'),submit=bar.querySelector('[data-bb-sticky-submit]'),price=bar.querySelector('[data-bb-sticky-price]'),label=bar.querySelector('[data-bb-sticky-label]');if(!form||!buy)return;function state(){if(innerWidth>640){bar.classList.remove('is-visible');bar.setAttribute('aria-hidden','true');return}const r=buy.getBoundingClientRect(),p=product.getBoundingClientRect(),show=r.bottom<0&&p.bottom>120;bar.classList.toggle('is-visible',show);bar.setAttribute('aria-hidden',show?'false':'true')}submit?.addEventListener('click',()=>{const main=form.querySelector('[data-bb-add]');if(main&&!main.disabled)form.requestSubmit(main)});document.addEventListener('change',e=>{const s=e.target.closest('[data-bb-variant]');if(!s||!product.contains(s))return;const o=s.options[s.selectedIndex],ok=o.dataset.available==='true';if(price)price.textContent=o.dataset.price||'';submit.disabled=!ok;if(label)label.textContent=ok?'In den Warenkorb':'Ausverkauft'});addEventListener('scroll',state,{passive:true});addEventListener('resize',state,{passive:true});state()})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-qa-performance-polish"] && !Shopify.designMode) return;
  try {
    
(function(){
  function isVisible(element){
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  document.addEventListener('keydown',function(event){
    if(event.key!=='Tab')return;
    const drawer=document.querySelector('#BbCartDrawer.bbcd.is-open');
    if(!drawer)return;
    const panel=drawer.querySelector('.bbcd__panel');
    if(!panel)return;
    const focusable=Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(element){
      return isVisible(element)&&element.getAttribute('aria-hidden')!=='true';
    });
    if(!focusable.length)return;
    const first=focusable[0];
    const last=focusable[focusable.length-1];
    if(event.shiftKey&&document.activeElement===first){
      event.preventDefault();
      last.focus();
    }else if(!event.shiftKey&&document.activeElement===last){
      event.preventDefault();
      first.focus();
    }
  },true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-search-polish"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click',function(event){
    if(!event.target.closest('.js-search-header'))return;
    requestAnimationFrame(function(){setTimeout(function(){
      const input=document.querySelector('.site-header__search-container.is-active .site-header__search-input');
      if(input)input.focus({preventScroll:true});
    },40)});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-snack-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var state = { goal:'', protein:'' };
    var result = root.querySelector('[data-bbg-result]');
    var title = root.querySelector('[data-bbg-result-title]');
    var copy = root.querySelector('[data-bbg-result-copy]');
    var primary = root.querySelector('[data-bbg-primary]');
    var secondary = root.querySelector('[data-bbg-secondary]');

    var goals = {
      kauen:['Kauartikel','/collections/kauartikel'],
      training:['Training & Snacks','/collections/leckerlies'],
      futter:['Futter entdecken','/collections/all'],
      offen:['Alle Produkte','/collections/all']
    };
    var proteins = {
      rind:['Rind','/collections/rind'],
      huhn:['Huhn','/collections/huhn'],
      fisch:['Fisch & Meerestiere','/collections/fisch-meerestiere'],
      lamm:['Lamm','/collections/lamm'],
      kaninchen:['Kaninchen','/collections/kaninchen'],
      ente:['Ente','/collections/ente'],
      wild:['Wild','/collections/wild'],
      egal:null
    };

    function render(){
      if(!state.goal || !state.protein){
        result.hidden = true;
        return;
      }

      var goal = goals[state.goal];
      var protein = proteins[state.protein];
      title.textContent = 'Deine Startpunkte sind bereit.';
      primary.href = goal[1];
      primary.textContent = goal[0] + ' ansehen';

      if(protein){
        copy.textContent = 'Starte bei ' + goal[0] + '. Für ' + protein[0] + ' kannst du zusätzlich direkt in die passende Proteinwelt wechseln.';
        secondary.href = protein[1];
        secondary.textContent = protein[0] + ' ansehen';
        secondary.hidden = false;
      } else {
        copy.textContent = 'Starte in der passenden Kategorie und vergleiche dort Zusammensetzung, Varianten und Produkthinweise.';
        secondary.hidden = true;
      }
      result.hidden = false;
    }

    root.querySelectorAll('[data-bbg-step]').forEach(function(step){
      var key = step.dataset.bbgStep;
      step.querySelectorAll('button').forEach(function(button){
        button.setAttribute('aria-pressed','false');
        button.addEventListener('click',function(){
          step.querySelectorAll('button').forEach(function(item){
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed','false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed','true');
          state[key] = button.dataset.value;
          render();
        });
      });
    });
  }

  document.querySelectorAll('[data-bbg-finder]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){
    event.target.querySelectorAll('[data-bbg-finder]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
